<template>
    <div class="task">
        <div class="header">
            <div class="">
                <span>{{num}}</span>
                <span>/{{list.length}}已完成</span>
            </div>
            <div>
                <span>{{scores}}</span>
                <span>分</span>
            </div>
        </div>
        <div class="list">
            <div class="item" v-for="(item,index) in list" @click="goto(item)">
                <div :class="['left',(item.state == 1)?'check':'',index < list.length-1?'bot':'',(index < list.length && item.state == 1)?'sbot':'']">
                </div>
                <div class="right">
                    <div>
                        <div>
                            <img :src="item.icon" />
                        </div>
                        <div class="title">
                            <div class="it">{{item.title}}</div>
                            <div class="cont">{{item.duration}}</div>
                        </div>
                    </div>
                    <div :class="[(item.state == 1)?'checkin':'']">{{item.state == 1?item.score:item.state == 0?'计算中':'未完成'}}</div>
                </div>
            </div>           
        </div>
        <div class="footer">
            <div class="btn ho" @click="go">返回</div>
            <div class="btn" v-if="num>0&& num == list.length" @click="goshow">
                领取勋章
            </div>
            <div class="btn" v-else @click="goDetail">{{num==0?'开始训练':'继续训练'}}</div>
        </div>
        <div class="float">
            <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20220830/1661862318/368107.png" @click="godraw" alt="" >
        </div>
    </div>
</template>

<script>
import './index.less'
export default {
    data() {
        return {
            list: [],
            scores: 0,
            num: 0,
        }
    },
    mounted() {
        this.getlist()
        this.getstatus()
        window.localStorage.setItem("getPath", '/xh/task/'+this.$route.params.taskid+'/'+this.$route.params.sportsid);
    },
    methods: {
        godraw() {
            this.$router.push({name:'luckdraw',params: {acid:1302}})
        },
        getstatus() {
            let query = {
                taskid: this.$route.params.taskid,
                sportsid: this.$route.params.sportsid
            }
            this.$api.sports.getTastStatus(query).then(res=>{
                this.isfinish = res.data.isfinish
                this.task = res.data.task
            })
        },
        goshow() {
            window.location.href = this.task.cert
        },
        gorepet() {
            this.$dialog
            .confirm({
                title: "提示",
                message: "提交后将不可会退。确定提交?",
            })
            .then(() => {
                let query = {
                    taskid: this.$route.params.taskid,
                    sportsid: this.$route.params.sportsid
                }
                this.$api.sports.reTast(query).then(res=>{
                    this.getlist()
                    this.getstatus()
                })
            }).catch(() => {
                // on cancel
            });
        },
        getlist() {
            let query = {
                taskid: this.$route.params.taskid,
                sportsid: this.$route.params.sportsid
            }
            this.$api.sports.getTastInfo(query).then(res=>{
                if(res.status === 200) {
                    this.list = res.data
                    var scores = 0
                    var num = 0
                    res.data.forEach(item => {
                        if(item.state == 1) {
                            scores += item.score*1
                            num ++
                        }
                    });
                    this.scores = scores.toFixed(2)
                    this.num = num
                }
            })
        },
        go() {
            this.$router.push({name:'aisports'})
        },
        goto(item) {
            if(item.state == 0 ||  item.state == 1) {
                this.$router.push({name:'taskinfo',params:{sports_id: this.$route.params.sportsid,item_sub_id:item.id,taskid:this.$route.params.taskid}})
            }       
        },
        goDetail() {
            let item = this.list.find(ele => ele.state == '' || ele.state == null)
            if(item) {
                this.$router.push({name:'taskinfo',params:{sports_id: this.$route.params.sportsid,item_sub_id:item.id,taskid:this.$route.params.taskid}})
            }
            
        },
    }
}
</script>